import { GeographicLevel } from 'app/shared/model/enumerations/geographic-level.model';

export interface IDisability {
  id?: string;
  geographicLevel?: keyof typeof GeographicLevel;
  date?: string;
  geography?: string;
  geographyCode?: string;
  totalAllUsualResidents?: number | null;
  disabledUnderDisabilityAct?: number | null;
  notDisabledUnderDisabilityAct?: number | null;
}

export const defaultValue: Readonly<IDisability> = {};
